module.exports = __webpack_public_path__ + "static/tv-purva-stupka-4df79e036912534a11275fe8aec10b4e.svg";